// extracted by mini-css-extract-plugin
module.exports = {"mainPostContainer":"NewPost_mainPostContainer__1GI0M","newPostButton":"NewPost_newPostButton__25JWy","buttonArea":"NewPost_buttonArea__2J668"};